/**
 * The web shell's guest account (handegg-accounts-spec.md §3): same `AccountClient` as the app, on the lobby's
 * origin (`defaultServerUrl` → https://<host>), localStorage-persisted. A host without the account API (the Node dev
 * server, a static deploy) simply fails the bootstrap and the wallet stays local.
 */
import { AccountClient, accountBaseFromWsUrl } from '@hf/client-core/account/account-client';
import type { NetEnv } from '@hf/client-core/net/env';
import { getPlatform } from '@hf/client-core/platform';
import { PORTAL } from '../portal';

const base =
  typeof window === 'undefined' || PORTAL
    ? null
    : accountBaseFromWsUrl(
        `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws`,
      );

export const account: AccountClient | null = base
  ? new AccountClient({
      baseUrl: base,
      storage: getPlatform().storage(),
      fetch: (u, i) => fetch(u, i),
      platform: 'web',
    })
  : null;

/** Lobby sockets carry the current access token when there is one (else a legacy, unauthenticated socket). */
let lastSocketAuthed = false;
/** The most recent lobby socket was opened with an access token (the server can attribute online rewards). */
export const lobbySocketAuthed = (): boolean => lastSocketAuthed;

export const withAccountSockets = (env: NetEnv): NetEnv => ({
  ...env,
  createSocket: (url) => {
    const t = account?.accessToken() ?? null;
    lastSocketAuthed = !!t;
    return env.createSocket(t ? `${url}${url.includes('?') ? '&' : '?'}token=${encodeURIComponent(t)}` : url);
  },
});
